import MentorSignup from '../components/signuppage/MentorSignup';

const MentorSignupPage = () => {
    return (
        <>
            <MentorSignup />
        </>
    );
};

export default MentorSignupPage;
